// defaultWheelChartData.js — gordon-0920-default-wheel-and-create-wheel-hero-
// geometry-must-match-standard-wheel-REPEAT-COMPLAINT.
//
// THE single fixed segment list for every "no wheel chosen yet" / decorative
// depiction of a Wheel that must nonetheless be geometry-conformant to a real
// data Wheel: the Collections default cover (CollectionCard.jsx), the
// Move-to-Collection picker's default cover (CollectionPickerTile/index.jsx),
// and the Create-Wheel hero (CreateWheelPopup's TopCircle). All three render
// this SAME chartData through the SAME WheelComponent/createPie.js engine a
// real Wheel uses (see DefaultWheelRing.jsx) — never a hand-rolled SVG or a
// static image asset — so divider width, outer hairline, white rim and ring
// thickness are byte-identical to a real Wheel's at any render size, by
// construction (one geometry, not a second approximation of it).
//
// Spans/colors are BrandWheel's own existing on-brand default
// (BRAND_WHEEL_SPANS/BRAND_WHEEL_PALETTE, src/components/BrandWheel/brandWheel.js)
// so the PALETTE stays identical to every other decorative Wheel mark in the
// app (loaders, favicons, NotFound) — only the RENDERER changes here.
import { BRAND_WHEEL_SPANS, BRAND_WHEEL_PALETTE } from "../BrandWheel/brandWheel";

export const DEFAULT_WHEEL_CHART_DATA = BRAND_WHEEL_SPANS.map((span, i) => ({
  id: `default-wheel-segment-${i}`,
  value: span,
  color: BRAND_WHEEL_PALETTE[i % BRAND_WHEEL_PALETTE.length],
  title: "",
  position: i,
}));
